import {
  EarthLock,
  Landmark,
  Newspaper,
  Package,
  ReceiptCent,
  WalletCards,
} from "lucide-react";
import MainContainer from "../../components/container/MainContainer";
import TransactionGridItem from "../../components/container/TransactionGridItem";
import TransactionGridContainer from "../../components/container/TransactionGridContainer";

const Transaction = () => {
  return (
    <MainContainer>
      <div>
        <h3 className="text-text-1/80">Transactions</h3>

        <TransactionGridContainer title="Receipts | Payments | Pledges">
          <TransactionGridItem
            component={ReceiptCent}
            title="Receipt"
            link="/accounts/receipts"
          />
          <TransactionGridItem
            component={Landmark}
            title="Payment"
            link="/accounts/payments"
          />
          <TransactionGridItem
            title="Pledge"
            component={Landmark}
            link="/pledges/create-pledge"
          />
        </TransactionGridContainer>

        {/* Journal */}
        <TransactionGridContainer title="Journal">
          <TransactionGridItem
            component={Package}
            title="Journal Entry"
            link="/accounts/journal-entry"
          />
          <TransactionGridItem
            component={Package}
            title="Journal Batches"
            link="/accounts/journal-batch-entry"
          />
          <TransactionGridItem
            component={EarthLock}
            title="Journal Transfer"
            link="/accounts/journal-transfer"
          />
        </TransactionGridContainer>
      </div>
    </MainContainer>
  );
};

export default Transaction;
